<template>
  <div class="mt-5">
      
        <v-snackbar
      v-model="snackbar"
    >
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
      <v-row no-gutters style="min-height:90vh" align="center" justify="center">
        <v-col
        cols="4"
        >

        <p class="text-center text-h4 font-weight-bold">Create an account</p>

      <p class="text-center text-caption font-weight-bold">ZAASTRY REWARDS</p>
      <p class="text-caption text-center">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iure tempora ut odit aperiam ipsa!</p>
          <v-card class="pa-5">
             <p class="font-weight-bold">Personal Information</p>
              <p class="mb-10"></p>
             <v-text-field
              outlined
              dense
              label="First name"
              v-model="firstname"
             />
             <v-text-field
              outlined
              dense
              label="Last name"
              v-model="lastname"
            />
            <v-text-field
              outlined
              dense
              label="Username"
              v-model="username"
            />
            <v-text-field
              outlined
              dense
              label="Photo"
              v-model="photo"
            />

            <p class="mb-10"></p>

            <p class="font-weight-bold">Account Security</p>

            <v-text-field
              outlined
              dense
              label="Email"
              v-model="email"
            />
             <v-text-field
              outlined
              dense
              label="Phone"
              v-model="phone"
            />
            <!-- Nickname for password -->
            <v-text-field
              outlined
              dense
              label="Password"
              v-model="password"
            />

          <p class="mb-5"></p>
          <p class="font-weight-bold pink--text">Already have a zaastry giftcard?</p>
          <p class="mb-4"></p>
          <p class="font-weight-bold grey--text">COLLECT MORE STARS & EARN REWARDS</p>
          <p class="mb-4"></p>
          <p>Email is a great way to know about offers and what’s new from Zaastry.</p>
          <p class="mb-4"></p>
          <v-checkbox label="Yes, I’d like email from Zaastry"></v-checkbox>
          <p class="mb-4"></p>
          <p class="ml-8">Know about initiatives, announcements and product offers.</p>
          <p class="mb-4"></p>
          <p class="font-weight-bold">TERMS OF USE</p>
          <v-checkbox label="I agree to the 
            Zaastry® Rewards Terms
             and the 
            Zaastry Card Terms
            "></v-checkbox>

              <p class="mb-4"></p>
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-btn x-large rounded dark color="green lighten-1" @click="register" style="text-transform:none"> Create Account</v-btn>
            </v-row>
          </v-card>
          <p class="mb-6"></p>
        </v-col>

      </v-row>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data(){
    return {
      firstname:"",
      lastname:"",
      email:"",
      phone:"",
      photo:"",
      password:"",
      username:"",
      text:"",
      snackbar:false
    }
  },
  methods:{
    register(){
      axios.post('https://zaastry-node.herokuapp.com/customer/create',{
        firstname:this.firstname,
        lastname:this.lastname,
        email:this.email,
        phone:this.phone,
        photo:this.photo,
        password:this.password,
        username:this.username
      }).then(res=>{
        console.log(res.data)
        this.text="You have registered successfully!"
        this.snackbar=true
        setTimeout(() => {
          this.$router.push('/login')
        }, 1000);

      }).catch(err=>{
        console.log(err)
        this.text="Error, Please try again!"
        this.snackbar=true
        
      })
    }
  }
}
</script>

<style>

</style>